var exports = {
  "my": "avatar__sd2e1k",
  "fh": "authorName__16v5kA",
  "T7": "postedText__TeTqkd",
  "Ls": "commentIcon__4V0jP7",
};

module.exports = exports;
